import { APICore } from 'helpers/api/apiCore';
import config from '../../config';
import { AggregateLimitV2FreezeUnfreezePayload, ApproveLimitV2Payload, CreateDraftLimitV2Payload, PublishLimitV2Payload, RejectLimitV2Payload, UpdateDraftLimitV2Payload } from './types';


const api = new APICore();

function listApprovedLimitsV2Api(customerExternalId: string) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2`;
  return api.get(baseUrl, {});
}

function latestVersionLimitsV2Api(customerExternalId: string) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2/latestVersion`;
  return api.get(baseUrl, {});
}

function createDraftLimitV2Api(customerExternalId: string, data: CreateDraftLimitV2Payload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2?draft=true`;
  return api.create(baseUrl, data);
}

function publishLimitV2Api(customerExternalId: string, data: PublishLimitV2Payload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2?draft=false`;
  return api.update(baseUrl, { makerRemarks: data.makerRemarks });
}

function updateDraftLimitV2Api(customerExternalId: string, data: UpdateDraftLimitV2Payload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2?draft=true`;
  return api.update(baseUrl, data);
}

function approveLimitV2Api(customerExternalId: string, data: ApproveLimitV2Payload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2/approve`;
  return api.updatePatch(baseUrl, { checkerRemarks: data.checkerRemarks.trim() });
}

function rejectLimitV2Api(customerExternalId: string, data: RejectLimitV2Payload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2/reject`;
  return api.updatePatch(baseUrl, { checkerRemarks: data.checkerRemarks.trim() });
}

function deleteLimitV2Api(customerExternalId: string) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2`;
  return api.delete(baseUrl);
}

function deleteLimitV2ByExternalIdApi(customerExternalId: string, borrowerLimitExternalId: string) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2/${borrowerLimitExternalId}`;
  return api.delete(baseUrl);
}

function freezeLimitV2Api(customerExternalId: string, data: AggregateLimitV2FreezeUnfreezePayload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2/freeze`;
  return api.updatePatch(baseUrl, { inactiveReason: data.inactiveReason.trim() });
}

function unfreezeLimitV2Api(customerExternalId: string, data: AggregateLimitV2FreezeUnfreezePayload) {
  const baseUrl = `${config.BACKEND_BASE_URL}/customers/${customerExternalId}/limitsV2/unfreeze`;
  return api.updatePatch(baseUrl, { inactiveReason: data.inactiveReason.trim() });
}

export { listApprovedLimitsV2Api, latestVersionLimitsV2Api, createDraftLimitV2Api, publishLimitV2Api, updateDraftLimitV2Api, approveLimitV2Api, rejectLimitV2Api, deleteLimitV2Api, deleteLimitV2ByExternalIdApi, freezeLimitV2Api, unfreezeLimitV2Api };
